import axios from 'axios';
import * as logger from '../../helpers/logger';
import { DONACO_MERCHANT_ID } from '../../paypal';
import { functionsURL } from '../../firebase';

/********** Partner API ***********/

async function callPayPalAPI(path: string, method: 'get' | 'post' | 'patch' = 'get', request_data: any = null) {
  try {
    const { data } = await axios.request({
      baseURL: functionsURL,
      url: 'paypal-api',
      method: 'post',
      data: {
        path,
        method,
        data: request_data,
      },
    });
    if (data.error) {
      throw new Error(data.error);
    }
    return data.paypal_response;
  } catch (error) {
    logger.error(error);
    return null;
  }
}

/**
 * Get account status
 * @param seller_merchant_id
 */
export const get_seller_status = async (seller_merchant_id: string) => {
  const data = await callPayPalAPI(`/v1/customer/partners/${DONACO_MERCHANT_ID}/merchant-integrations/${seller_merchant_id}`);
  return data;
};

/********** Orders API ***********/
/**
 * Get order details
 * @param order_id :string
 */
export const get_order_details = async (order_id: string) => {
  const data = await callPayPalAPI(`/v2/checkout/orders/${order_id}`);
  return data;
};

/**
 * Get capture details
 * @param capture_id :string
 */
export const get_capture_details = async (capture_id: string) => {
  const data = await callPayPalAPI(`/v2/payments/captures/${capture_id}`);
  return data;
};
